import ApiService from "@/services/api.service";

export default {
    namespaced: true,
    state: {
        listConservazione: {},
        loading: false,
        testingConnection: false,
        globalLoading: false,
        error: {},
    },
    getters: {
        getListConservazione: (state) => state.listConservazione,
        getLoading: (state) => state.loading,
        error: (state) => state.error,
    },
    mutations: {
        SET_CONSERVAZIONI_LIST(state, listConservazione) {
            state.listConservazione = listConservazione;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_LOADING_TEST(state, val) {
            state.testingConnection = val;
        },
        SET_GLOBAL_LOADING(state, val) {
            state.globalLoading = val;
        },
        SET_ERROR(state, val) {
            state.error = val;
        },
    },
    actions: {
        FETCH_LIST_CONSERVAZIONI({ commit }, query) {
            commit("SET_LOADING", true);

            return new Promise((resolve) => {
                ApiService.get(`conservazione/paginated?${query}`)
                    .then((res) => {
                        commit("SET_CONSERVAZIONI_LIST", res.data);
                        commit("SET_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => {
                            commit("SET_ERROR", "");
                            commit("SET_LOADING", false);
                        }, 5000);
                    });
            });
        },
        GET_NOME_ARCHIVIO({ commit }, nomeArchivio) {
            return new Promise((resolve) => {
                ApiService.normalPost(
                    `Conservazione/rilanciaArchivioConservazione?nomeArchivio=${nomeArchivio}`
                )
                    .then((res) => {
                        console.log("list", res);
                        resolve(res.data);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                    });
            });
        },
    },
};
